import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'
import { IUserDetails } from '../../interfaces/user.interface'
import { Button, MenuItem } from '@mui/material'
import { AxiosPromise } from 'axios'

import { formatAmount } from '../../services/utils'
import PayWithPaymentProvider from './PayWithProvider'

export default function PayWithPaymentProviderButton(props: {
  getCoupon: (code: string) => AxiosPromise
  school_details: ISchool
  userDetails: IUserDetails
  courseId?: string
  paymentPlanId?: string
  paymentPlanInvoiceId?: string
  amount: number
  paymentFor: 'school_fees' | 'add_card'
  productName: string
  onTransactionComplete?: () => void
  setTransactionComplete: (transactionComplete: boolean) => void
  buttonVariant?: 'contained' | 'outlined' | 'text'
  fullWidth?: boolean
  buttonSize?: 'large' | 'small' | 'medium'
  buttonStyle?: any
  openDialogByDefault?: boolean
  useMenuItemComponents?: boolean
  courseTier?: number
  buttonDisableElevation?: boolean
}) {
  const [openDialog, setOpenDialog] = React.useState(
    props.openDialogByDefault || false,
  )

  function toggleOpenDialogCoupon() {
    setOpenDialog(!openDialog)
  }

  return (
    <div
      style={{
        marginTop: '10px',
        alignItems: 'center',
        justifyContent: 'center',
        // display: "flex",
        // flexDirection: "column",
      }}
    >
      {!props.useMenuItemComponents && (
        <div style={{ textAlign: 'center' }}>
          <Button
            color="primary"
            fullWidth={props.fullWidth === undefined ? true : props.fullWidth}
            // style={{ marginRight: "5px", height: "50%" }}
            style={{ ...props.buttonStyle }}
            variant={props.buttonVariant || 'outlined'}
            disableElevation={props.buttonDisableElevation || false}
            size={props.buttonSize || 'large'}
            onClick={toggleOpenDialogCoupon}
          >
            Pay {`${props.school_details?.currency_symbol}`}{' '}
            {formatAmount(props.amount)}{' '}
            {props.courseTier
              ? `for tier ${props.courseTier} access`
              : 'for course'}
          </Button>
        </div>
      )}

      {props.useMenuItemComponents && (
        <div style={{ textAlign: 'center' }}>
          <MenuItem
            divider={true}
            color="primary"
            style={{ ...props.buttonStyle }}
            onClick={toggleOpenDialogCoupon}
          >
            Pay {`${props.school_details?.currency_code}`}{' '}
            {formatAmount(props.amount)}{' '}
            {props.courseTier
              ? `for tier ${props.courseTier} access`
              : 'for course'}
          </MenuItem>
        </div>
      )}

      <PayWithPaymentProvider
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        fullWidth={props.fullWidth}
        getCoupon={props.getCoupon}
        buttonVariant={props.buttonVariant}
        userDetails={props.userDetails}
        school_details={props.school_details}
        courseId={props.courseId}
        paymentPlanId={props.paymentPlanId}
        paymentPlanInvoiceId={props.paymentPlanInvoiceId}
        amount={props.amount}
        productName={props.productName}
        paymentFor={props.paymentFor}
        setTransactionComplete={props.setTransactionComplete}
        onTransactionComplete={props.onTransactionComplete}
        buttonStyle={props.buttonStyle}
        courseTier={props.courseTier}
      />
    </div>
  )
}
